import React from 'react';

export const ChevronLeft = ({ color }: { color?: string }): JSX.Element => {
  const className = 'icon icon--chevron-left';
  color = color || '#0076CC';

  return (
    <svg
      width="9"
      height="16"
      viewBox="0 0 9 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...{ className }}
    >
      <path
        d="M8 15L1 8L8 1"
        stroke={color}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default ChevronLeft;
